import {React} from "react";
import { BrowserRouter as Router, Routes, Route, Link } from "react-router-dom";
import "katex/dist/katex.min.css";
//eslint-disable-next-line
const articles = [

  {
    id: 15,
    title: "Implementing a Stochastic Causal Reasoning Engine",
    slug: "Implementing a Stochastic Causal Reasoning Engine",
  },



  {
    id: 1,
    title: "Leveraging Symmetry and Information Theory to Reduce Redundancy in Systems",
    slug: "Leveraging-Symmetry-and-Information-Theory-to-Reduce-Redundancy-in-Systems",
  },
  {
    id: 3,
    title: "The Cube Model: A Model Concept for Non-Linear Systems Simulation, Chaos Modeling and Adaptive Processing",
    slug: "The-Cube-Model:-A-Model-Concept-for-Non-Linear-Systems-Simulation,-Chaos-Modeling-and-Adaptive-Processing",
  },

  {
    id: 4,
    title: "Optimizing Resource Allocation: A Hybrid System (Discrete & Continuous) for Efficient Scaling",
    slug: "Optimizing-Resource-Allocation:-A-Hybrid-System-(Discrete-&-Continuous)-for-Efficient-Scaling"
  },

  {
    id: 5,
    title: "The Self-Healing Equation: A Universal Framework for Stability, Adaptation, and Chaos Management",
    slug: "The-Self-Healing-Equation:-A-Universal-Framework-for-Stability,-Adaptation,-and-Chaos-Management"
  },

  {
    id: 6,
    title: "Embracing Failure as a Core Design Element in Systems: An Extension of the Self Healing Framework",
    slug: "Embracing-Failure-as-a-Core-Design-Element-in-Systems:-An-Extension-of-the-Self-Healing-Framework"

  },
  {
    id: 7,
    title: "Exploring Chaos Modulation in Model Reference Adaptive Control (MRAC): An Application of the Self Healing Framework in Control Systems",
    slug: "Exploring-Chaos-Modulation-in-Model-Reference-Adaptive-Control-(MRAC):-An-Application-of-the-Self-Healing-Framework-in-Control-Systems"},

    {
      id: 10,
      title:"Exploring the Recursive Duality of Discrete-Continuous Systems: A Theoretical Framework for Emergence Analysis",
      slug:"Exploring the Recursive Duality of Discrete-Continuous Systems: A Theoretical Framework for Emergence Analysis"},


    {
      id: 11,
      title:"Structural Optimization Through Shared Continuous-Discrete Origins: A Recursive Validation of Self-Similarity in Emergent Systems",
      slug:"Structural Optimization Through Shared Continuous-Discrete Origins: A Recursive Validation of Self-Similarity in Emergent Systems"},




];

const Home = () => {
  
  return (
    <div className="app">
      <div className="home">
        <header className="header">
          <div className="hero-section">
            <h1 className="gradient-text">Exploring Computational Engineering<br/> & Systems Theory</h1>
            <p className="hero-subtitle">
              Insights, ideas, and explorations into systems design, computational systems, algorithm design, Artificial Intelligence, and cutting-edge technology.
            </p>
          </div>
        </header>

        <main className="content">
          <section className="section-card">
            <h2>Welcome to my Technical Journal</h2>
            <div className="about-content">
              <p className="intro-text">
                I'm <strong>Tom Muga</strong>, a Software Engineer who loves deep exploration of advanced systems design, computational frameworks and AI. I would absolutely love to discuss and share ideas and do collaborations. Contact me via my email. Hve fun rreading my articles, feedback is always welcomed☺️
              </p>

              <div className="contact-actions">
                <a href="mailto:tonmuga@gmail.com" className="button" style={{marginRight:".5%", textDecoration:"None"
                }}>
                  Contact via Email
                </a>
                <a 
                  href="https://github.com/tommygrammar" 
                  className="button"
                  target="_blank" 
                  rel="noopener noreferrer"
                  style={{textDecoration:"None"
                  }}
                >
                  View GitHub
                </a>
              </div>
            </div>
          </section>

          <section className="section-card">
            <h2>Featured Articles</h2>
            <div className="article-grid">
              {articles.map((article) => (
                <Link 
                  to={`/${article.slug}`} 
                  key={article.id}
                  className="article-card"
                >
                  <h3>{article.title}</h3>
                  <div className="card-hover-indicator">
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
                      <path d="M5 12H19M19 12L13 6M19 12L13 18" stroke="currentColor" strokeWidth="2"/>
                    </svg>
                  </div>
                </Link>
              ))}
            </div>
          </section>
        </main>
      </div>

      <footer className="footer">
        <p>&copy; 2025 Tom Muga. All rights reserved.</p>
      </footer>
    </div>
  );
};
export default Home;
